import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from '../../styles/Team.module.css';

const ClientList = ({ clients, onClientSelect }) => {
  const getStatusColor = (status) => {
    return status === 'active' ? styles.statusActive : styles.statusInactive;
  };

  const getStatusIcon = (status) => {
    return status === 'active' ? 'check-circle' : 'times';
  };

  return (
    <div className={styles.clientListContainer}>
              <div className={styles.clientListHeader}>
          <div className={styles.clientNameHeader}>
            <FontAwesomeIcon icon="user" style={{ marginRight: '6px', opacity: 0.7 }} />
            Client
          </div>
          <div className={styles.clientJoinHeader}>
            <FontAwesomeIcon icon="calendar-plus" style={{ marginRight: '6px', opacity: 0.7 }} />
            Join Date
          </div>
          <div className={styles.clientSpentHeader}>
            <FontAwesomeIcon icon="dollar-sign" style={{ marginRight: '6px', opacity: 0.7 }} />
            Page Earned
          </div>
          <div className={styles.clientEarningsHeader}>
            <FontAwesomeIcon icon="money-bill-wave" style={{ marginRight: '6px', opacity: 0.7 }} />
            Your Earnings
          </div>
          <div className={styles.clientStatusHeader}>
            <FontAwesomeIcon icon="circle" style={{ marginRight: '6px', opacity: 0.7 }} />
            Status
          </div>
        </div>
      
      <div className={styles.clientList}>
        {clients.map((client) => (
          <div 
            key={client.id}
            className={styles.clientItem}
            onClick={() => onClientSelect(client)}
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                onClientSelect(client);
              }
            }}
            role="button"
            aria-label={`View details for ${client.name}`}
          >
            <div className={styles.clientNameCell}>
              <div className={styles.clientAvatar}>
                {client.name.charAt(0).toUpperCase()}
              </div>
              <div className={styles.clientInfo}>
                <div className={styles.clientName}>{client.name}</div>
                <div className={styles.clientEmail}>{client.email}</div>
              </div>
            </div>
            
            <div className={styles.clientJoinCell}>
              <span className={styles.clientJoinDate}>
                {new Date(client.joinDate).toLocaleDateString()}
              </span>
            </div>
            
            <div className={styles.clientSpentCell}>
              <span className={styles.clientSpentAmount}>
                ${client.totalSpent.toLocaleString()}
              </span>
            </div>
            
            <div className={styles.clientEarningsCell}>
              <span className={styles.clientEarningsAmount}>
                ${client.affiliateEarnings.toLocaleString()}
              </span>
            </div>
            
            <div className={styles.clientStatusCell}>
              <span className={`${styles.clientStatus} ${getStatusColor(client.status)}`}>
                <FontAwesomeIcon icon={getStatusIcon(client.status)} />
                {client.status}
              </span>
            </div>
            
            <div className={styles.clientAction}>
              <FontAwesomeIcon icon="chevron-right" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientList; 